<template>
    <div class="right">
        <el-button type="primary" class="right input-field button" @click="confirmButton"> {{ $t('navigationButtonFinish') }} </el-button>
        <el-button class="right input-field button" @click="$router.push({name: discardPath})"> {{ $t('navigationButtonCancel') }} </el-button>
        <el-button
            class="right input-field button"
            icon="el-icon-back"
            @click="$router.go(-1)"
        >
            {{ $t('navigationButtonBack') }}
        </el-button>
        <modal
            :config="modalConfig"
            :title="$t('modalUpdateTitle')"
            :text="$t('modalUpdateText')"
            @click="$router.push({name: discardPath})"
            @closeModal="fireEvent"
        />
    </div>
</template>

<script>
    import Modal from '../Modal/Modal'
    import {showModal, closeModal} from "../Modal/ModalHelpers"
    
    export default {
        components: {
            'modal': Modal  
        },
        props: {
            type: {},
            isEdit: {
                type: Boolean,
                default: false
            },
            discardPath: {
                type: String,
                default: 'Index'
            }
        },
        data() {
            return {
                modalConfig: { show: false }
            }  
        },
        methods: {
            closeModal,
            showModal,
            fireEvent () {
                this.modalConfig.show = false
                this.$emit('confirm-event-fired')
            },
            confirmButton() {
                if (this.isEdit) {
                    this.modalConfig.show = true;
                } else {
                    this.fireEvent();
                }
            }
        }
    }
</script>

<style scoped>
    .block {
        display: inline-block;
    }

    .right {
        float: right;
    }

    .input-field {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .button {
        margin-left: 10px;
        width: 120px;
    }

    .error-msg {
        color: red;
        margin-bottom: 5px;
        display: block;
        margin-top: 3px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Shared/SharedButtons.vue